import { render, staticRenderFns } from "./page-foot-page.vue?vue&type=template&id=4d6a1d1f&"
import script from "./page-foot-page.vue?vue&type=script&lang=js&"
export * from "./page-foot-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports